import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
    LsqCommonModule,
    LsqTablesModule,
    LsqCoreModule,
    LsqModalsModule
} from '@lsq-frontend/common-ui';
import { PopoverModule } from 'ngx-smart-popover';
import { DrApplicationSharedComponentsModule } from '@lsqlabs/dr-application-shared';
import { DynamicContainerBase } from '@lsqlabs/dr-application-shared';
import { DocumentsRoutingModule } from './documents-routing.module';
import { ViewDocumentsComponent } from './documents.component';
import { AppCommonModule } from '../app-common.module';

@NgModule({
    imports: [
        DocumentsRoutingModule,
        DrApplicationSharedComponentsModule,
        CommonModule,
        LsqCoreModule.forRoot(),
        LsqCommonModule.forRoot(),
        LsqTablesModule.forRoot(),
        LsqModalsModule,
        PopoverModule,
        AppCommonModule,
        HttpClientModule
    ],
    declarations: [ViewDocumentsComponent],
    providers: [DynamicContainerBase]
})
export class DocumentsModule {}
